import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { isApiError } from "@empite/api-client";
/**
 * useZodForm is React Hook Form with the Zod resolver already attached.
 *
 * One helper rather than each screen wiring its own resolver, because the
 * schema is then the ONLY description of a form's shape: the TypeScript type
 * of the values, the validation rules and the parsed output all come from it,
 * and there is no second list of fields to forget to update.
 */
export function useZodForm(schema, options = {}) {
    return useForm({
        ...options,
        // Validate on the blur that follows a first failed submit, not on every
        // keystroke: telling someone their email is invalid while they are still
        // typing the domain is noise they learn to ignore.
        mode: options.mode ?? "onTouched",
        resolver: zodResolver(schema),
    });
}
/**
 * applyApiFieldErrors moves a rejected request's per-field violations onto
 * the form that produced them.
 *
 * The platform validates server-side and answers with `errors: [{field,
 * message}]`; without this the user sees a banner saying something is wrong
 * and no indication of which input. Anything the form has no field for falls
 * back to the form-level error, so a violation is never silently swallowed.
 */
export function applyApiFieldErrors(setError, error, knownFields) {
    if (!isApiError(error) || error.fieldErrors.length === 0) {
        return false;
    }
    let applied = false;
    for (const violation of error.fieldErrors) {
        const field = violation.field;
        if (knownFields && !knownFields.includes(field)) {
            continue;
        }
        setError(field, { type: "server", message: violation.message });
        applied = true;
    }
    return applied;
}
//# sourceMappingURL=forms.js.map